import React from "react";
import ss1 from "../../assets/screenshots/jiraticketgenerator/ss1.png";
import banner from "../../assets/projects/jiraticketcreation.png";
const JiraTicketGeneratorPage = () => (
  <main className="container mx-auto max-width pt-10 pb-20 space-y-16">
    {/* Banner Image */}
    <section className="w-full">
      <img
        src={banner}
        alt="Jira Ticket Generator Banner"
        className="w-[500px] rounded-xl shadow-md object-cover"
      />
    </section>

    {/* Project Title & Overview */}
    <section>
      <h1 className="text-4xl xl:text-5xl font-bold text-dark-heading dark:text-light-heading mb-4">
        Automating Jira Ticket Creation with AI
      </h1>
      <p className="text-lg text-content lg:max-w-4xl">
      Creating support issue tickets and feature request tickets across Slack and Jira quickly became time-consuming for the client. Conversations were getting lost, and valuable feedback wasn’t turning into action fast enough. To solve this, I created the Jira Ticket Generator, a smart, fully automated workflow built with n8n that transforms casual Slack messages into clean, categorized Jira tickets. Using the ChatGPT API, the system intelligently interprets each message and generates the appropriate ticket, either as a Bug or a Task, directly in Jira. If the request is valid, the bot responds in Slack with a direct link to the new ticket. If not, it replies with a clear explanation. The result is a streamlined, intelligent system that saves time.
</p>

    </section>

    {/* Technology Stack */}
    <section>
      <h2 className="text-3xl font-semibold text-dark-heading dark:text-light-heading mb-4">
        💻 Technology Stack
      </h2>
      <ul className="list-disc list-inside text-content space-y-2">
        <li><strong>n8n:</strong> Orchestrates the entire Slack-to-Jira automation workflow.</li>
        <li><strong>Slack:</strong> Serves as the input channel for user-reported issues or feature requests.</li>
        <li><strong>Jira Software:</strong> Destination for structured ticket creation (Bug Ticket & Task Ticket).</li>
        <li><strong>ChatGPT (OpenAI):</strong> Analyzes user messages, categorizes the requests, and generates the tickets.</li>
        <li><strong>Airtable:</strong> Provides context for the software details and flow, the context is used by the AI.</li>

      </ul>
    </section>

    {/* n8n Workflows */}
    <section>
      <h2 className="text-3xl font-semibold text-dark-heading dark:text-light-heading mb-4">
        🔄 n8n Automation Workflows
      </h2>
      <ul className="list-disc list-inside text-content space-y-2">
        <li><strong>Trigger & Capture:</strong> Detects bot mentions and extracts user intent and message details.</li>
        <li><strong>Enrich with Context:</strong> Retrieves relevant app data from Airtable to guide AI understanding.</li>
        <li><strong>AI-Powered Structuring:</strong> Uses OpenAI to analyze the message and generate a clear, actionable ticket.</li>
        <li><strong>Smart Validation:</strong> Determines ticket relevance and classifies it as a Bug or Task.</li>
        <li><strong>Seamless Ticketing:</strong> Creates the ticket in Jira and delivers an instant response back to the user.</li>

      </ul>
    </section>

    {/* Screenshots */}
    <section>
      <h2 className="text-3xl font-semibold text-dark-heading dark:text-light-heading mb-4">
        🖼️ Project Images & Screenshots
      </h2>
      <div className="flex flex-col gap-6">
           <div>
        <p className="mb-2 font-medium">Key Features</p>
        <a href={banner} target="_blank" rel="noopener noreferrer">
          <img src={banner} alt="Customer Feedback Workflow" className="w-full rounded-lg shadow" />
        </a>
      </div>
        <div>
          <p className="mb-2 font-medium">Jira Ticket Generator Workflow (n8n)</p>
          <a href={ss1} target="_blank" rel="noopener noreferrer">
            <img src={ss1} alt="Jira Ticket Generator Workflow (n8n)" className="w-full rounded-lg shadow" />
          </a>
        </div>

      </div>
    </section>
  </main>
);

export default JiraTicketGeneratorPage;
